import { addDays, startOfDay, startOfWeek } from 'date-fns';
import { DateTimeInput, SelectInput } from 'react-admin';

export type DatePreset = {
  id: string;
  name: string;
  filter: () => {
    createdAtGte?: Date | null;
    createdAtLte?: Date | null;
  };
};

export const datePresets: DatePreset[] = [
  {
    id: 'today',
    name: 'Today',
    filter: () => ({
      createdAtGte: startOfDay(new Date()),
    }),
  },
  {
    id: 'yesterday',
    name: 'Yesterday',
    filter: () => {
      const yesterday = startOfDay(addDays(new Date(), -1));

      return {
        createdAtGte: yesterday,
        createdAtLte: addDays(yesterday, 1),
      };
    },
  },
  {
    id: 'currentWeek',
    name: 'Current Week',
    filter: () => ({
      createdAtGte: startOfWeek(new Date(), { weekStartsOn: 1 }),
    }),
  },
  {
    id: 'last7days',
    name: 'Last 7 Days',
    filter: () => ({
      createdAtGte: addDays(new Date(), -7),
    }),
  },
  {
    id: 'lastWeek',
    name: 'Previous Week',
    filter: () => {
      const sevenDaysAgo = addDays(new Date(), -7);
      const lastWeek = startOfWeek(sevenDaysAgo, { weekStartsOn: 0 });

      return {
        createdAtGte: lastWeek,
        createdAtLte: addDays(lastWeek, 7),
      };
    },
  },
  {
    id: 'last30days',
    name: 'Last 30 Days',
    filter: () => ({
      createdAtGte: addDays(new Date(), -30),
    }),
  },
];

export const datePresetsMap = new Map(
  datePresets.map(preset => [preset.id, preset]),
);

export const createDateFilters = (
  fieldName: string,
  label?: string,
) => [
  <DateTimeInput
    key={`${fieldName}Gte`}
    source={`${fieldName}Gte`}
    label={`${label ? `${label} ` : ''}After`}
  />,
  <DateTimeInput
    key={`${fieldName}Lte`}
    source={`${fieldName}Lte`}
    label={`${label ? `${label} ` : ''}Before`}
  />,
  <SelectInput
    key={`${fieldName}Preset`}
    label="Date Preset"
    source={`${fieldName}DatePreset`}
    emptyText="All"
    choices={datePresets}
  />,
];
